import { AuthActionTypes } from './actionTypes';
import * as API from '../../API/authAPI';
import storage from 'Utility/storage';
import * as commonService from 'Utility/utility';
import axios from 'config';
import { toastMsg } from 'Utility/utility';
import * as actions from 'redux/actions/index';
import store from '../../redux/store/store';

export const login = (credentials) => {
   return (dispatch, getState) => {
      dispatch({
         type: AuthActionTypes.LOGIN,
         payload: API.login(credentials)
            .then((response) => {
               if (
                  response.data.success === true ||
                  response.data.success === 'true'
               ) {
                  storage.set('token', response.data.token);
                  storage.set('refresh_token', response.data.refresh_token);
                  storage.set('user', response.data.user);
               }

               return response.data;
            })
            .catch((error) => {
               console.log(error);
               return error;
            }),
      });
   };
};

export const signup = (credentials) => {
   return (dispatch, getState) => {
      dispatch({
         type: AuthActionTypes.SIGNUP,
         payload: API.signup(credentials)
            .then((response) => {
               if (
                  response.data.success === true ||
                  response.data.success === 'true'
               ) {
                  storage.set('token', response.data.token);
                  storage.set('refresh_token', response.data.refresh_token);
                  storage.set('user', response.data.user);
               }
               return response.data;
            })
            .catch((error) => {
               console.log(error);
               return error;
            }),
      });
   };
};

export const forgotPassword = (credentials) => {
   return (dispatch, getState) => {
      dispatch({
         type: AuthActionTypes.FORGOTPASSWORD,
         payload: API.forgotpassword(credentials)
            .then((response) => {
               if (
                  response.data.success === true ||
                  response.data.success === 'true'
               ) {
                  toastMsg('Please check your email to reset your password!');
                  return response.data;
               }
            })
            .catch((error) => {
               console.log(error);
               return error;
            }),
      });
   };
};

export const resetPassword = (credentials) => {
   return (dispatch, getState) => {
      dispatch({
         type: AuthActionTypes.RESETPASSWORD,
         payload: API.resetpassword(credentials)
            .then((response) => {
               if (
                  response.data.success === true ||
                  response.data.success === 'true'
               ) {
                  toastMsg('Your password has been changed');
                  return response.data;
               }
            })
            .catch((error) => {
               console.log(error);
               return error;
            }),
      });
   };
};

export const verfication = (credentials) => {
   return (dispatch, getState) => {
      dispatch({
         type: AuthActionTypes.VERIFICATION,
         payload: API.verfication(credentials)
            .then((response) => {
               if (
                  response.data.success === true ||
                  response.data.success === 'true'
               ) {
                  dispatch(actions.plans());
                  dispatch(userAPI());
                  return response.data;
               }
            })
            .catch((error) => {
               console.log(error);
               return error;
            }),
      });
   };
};

export const reverfication = (credentials) => {
   return (dispatch, getState) => {
      dispatch({
         type: AuthActionTypes.RESENDVERIFICATION,
         payload: API.resendverfication(credentials)
            .then((response) => {
               if (
                  response.data.success === true ||
                  response.data.success === 'true'
               ) {
                  toastMsg('Please Check your mail, The code has been sent!');
               }

               return response.data;
            })
            .catch((error) => {
               console.log(error);
               return error;
            }),
      });
   };
};

export const refreshToken = (credentials) => {
   commonService.isLoading.onNext(true);
   // refreshTokenPending();
   return API.refreshToken(credentials).then((response) => {
      commonService.isLoading.onNext(false);
      axios.defaults.headers.common[
         'Authorization'
      ] = `Bearer ${response.data.token}`;
      const { user, token, refresh_token } = response.data;
      storage.set('token', token);
      storage.set('refresh_token', refresh_token);
      storage.set('user', user);
      store.dispatch({
         type: AuthActionTypes.UPDATE_TOKEN,
         payload: { user, token, refresh_token },
      });
      return response.data;
   });
};

export const userAPI = () => {
   return (dispatch, getState) => {
      dispatch({
         type: AuthActionTypes.USERAPI,
         payload: API.userAPI()
            .then((response) => {
               if (
                  response.data.success === true ||
                  response.data.success === 'true'
               ) {
                  storage.set('user', response.data.user);

                  return response.data;
               }
            })
            .catch((error) => {
               console.log(error);
               return error;
            }),
      });
   };
};

export const logout = () => (dispatch) => {
   storage.remove('token');
   storage.remove('user');
   storage.remove('refresh_token');
   dispatch({
      type: AuthActionTypes.LOGOUT,
   });
};
